<template>
  <v-container
    id="clientes-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <div v-if="!paginaEnable">
      <h1 style="display: none">
        Usuário não tem permissão a essa página não existente
      </h1>
    </div>
    <div v-else>
      <v-row>
        <v-col
          cols="12"
          class="container"
        >
          <v-row id="analiseFaturamentoFltrosId">
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <dashboard-filtros
                :primeiro="enablePrimeiroDia"
                :ultimo="enableUltimoDia"
                :empresas="enableEmpresa"
                :url="link"
                :vendedores="enableVendedores"
                :areas="enableAreas"
                :redes="enableRedes"
                :supervisores="enableSupervisores"
                :receitas="enableReceita"
                :segmentos="enableSegmento"
                :categorias="enableCategoria"
                :promotores="enablePromotor"
                :classificacoes="enableClassificacao"
                :cidades="enableCidades"
                :produtos="enableProdutos"
                :linha-producao="enableLinhasProducao"
                :habilitar-filtros-data="enableFiltrosDados"
              />
            </v-col>
          </v-row>
          <v-row
            v-if="enableBtnPrint"
            id="btnPrint"
          >
            <v-btn
              class="col-4 col-sm-3 col-md-1 col-lg-1"
              small
              :color="corPrimaria"
              dark
              :loading="imprimindo"
              @click="imprimir()"
            >
              <v-icon>
                mdi-printer
              </v-icon>
              Imprimir
              <template v-slot:loader>
                <span>Imprimindo...</span>
              </template>
            </v-btn>
          </v-row>
          <v-divider class="mb-5" />
          <v-row id="bloco1IdPrint">
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <v-row>
                <v-col
                  id="componenteAnaliseProdutoFaturamento"
                  cols="12"
                  sm="3"
                  md="3"
                  lg="3"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'100'"
                    :text="'Faturamento - R$'"
                    :texto-information="textoFaturamento"
                    :style-object="styleObject"
                    :componente-valor="true"
                    :valor="valorFaturamento"
                    :padding="dynamicPaddingAnaliseProduto1"
                    :loading="loadingFaturamento"
                  />
                </v-col>
                <v-col
                  id="componenteAnaliseProduto"
                  cols="12"
                  sm="3"
                  md="3"
                  lg="3"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :text="'Volumetria (LITROS)'"
                    :code-information="'379'"
                    :texto-information="textoKgFaturado"
                    :style-object="styleObject"
                    :componente-valor="true"
                    :valor="`${valorKgFaturado}`"
                    :padding="dynamicPaddingAnaliseProduto1"
                    :loading="loadingKgFaturado"
                  />
                </v-col>
                <v-col
                  id="componenteAnaliseProduto"
                  cols="12"
                  sm="3"
                  md="3"
                  lg="3"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'101'"
                    :text="'Meta (Volume)'"
                    :texto-information="textoMeta"
                    :style-object="styleObjectMeta"
                    :componente-valor="true"
                    :valor="`${valorMeta} (${porcentagem}%)`"
                    :padding="dynamicPaddingAnaliseProduto1"
                    :loading="loadingMeta"
                  />
                </v-col>
                <v-col
                  id="componenteAnaliseProduto"
                  cols="12"
                  sm="3"
                  md="3"
                  lg="3"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :text="'Devoluções - R$'"
                    :code-information="'381'"
                    :texto-information="textoValorDevolucao"
                    :style-object="styleObjectDevolucao"
                    :componente-valor="true"
                    :valor="`${valorDevolucao} (${porcentagemDevolucao}%)`"
                    :padding="dynamicPaddingAnaliseProduto1"
                    :loading="loadingDevolucao"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row id="bloco2IdPrint">
            <v-col
              id="componenteAnaliseProdutoFaturamento"
              cols="12"
              sm="6"
              md="6"
              lg="6"
            >
              <dashoard-card-view
                :exibir-texto-titulo="true"
                :code-information="'296'"
                :text="'Faturamento por Linha - R$'"
                :texto-information="textoFatClassificacao"
                :style-object="styleObject"
                :componente-grafico="true"
                :grafico-id="'myChartAnaliseFaturamentoClassificacao'"
                :dados-grafico="chartBarFaturamentoClassificacao"
                :titulo-id="'myChartAnaliseFaturamentoClassificacao'"
                :legenda-grafico="legendaGraficoFaturamentoClassificacao"
                :exibir-legenda="enableLegenda"
                :padding="dynamicPaddingAnaliseProduto2"
                :loading="loadingFaturamentoClassificacao"
              />
            </v-col>
            <v-col
              id="componenteAnaliseProduto"
              cols="12"
              sm="6"
              md="6"
              lg="6"
            >
              <dashoard-card-view
                :exibir-texto-titulo="true"
                :code-information="'297'"
                :text="'Litros Total por Linha'"
                :texto-information="textoKgClassificacao"
                :style-object="styleObject"
                :componente-grafico="true"
                :grafico-id="'myChartFaturamentoKgGrupo'"
                :dados-grafico="chartBarFaturamentoKgGrupo"
                :titulo-id="'myChartFaturamentoKgGrupo'"
                :exibir-legenda="false"
                :padding="dynamicPaddingAnaliseProduto2"
                :loading="loadingFaturamentoKgGrupo"
              />
            </v-col>
          </v-row>
          <v-row id="bloco3IdPrint">
            <v-col
              id="componenteAnaliseProduto"
              cols="12"
              sm="6"
              md="6"
              lg="6"
            >
              <dashoard-card-view
                :exibir-texto-titulo="true"
                :code-information="'298'"
                :text="'Litros Médio por Linha'"
                :texto-information="textoPrecoMedioClassificacao"
                :style-object="styleObject"
                :componente-grafico="true"
                :grafico-id="'myChartFaturamentoPrecoMedio'"
                :dados-grafico="chartBarFaturamentoPrecoMedio"
                :titulo-id="'myChartFaturamentoPrecoMedio'"
                :exibir-legenda="false"
                :padding="dynamicPaddingAnaliseProduto2"
                :loading="loadingFaturamentoPrecoMedio"
              />
            </v-col>
            <v-col
              id="componenteAnaliseProduto"
              cols="12"
              sm="6"
              md="6"
              lg="6"
            >
              <dashoard-card-view
                :exibir-texto-titulo="true"
                :code-information="'310'"
                :text="'Devoluções Linha - R$'"
                :texto-information="textoDevolucaoOrcadoVendedor"
                :style-object="styleObject"
                :componente-grafico="true"
                :grafico-id="'myChartAnaliseProdutoDevolucao'"
                :dados-grafico="chartAnaliseProdutoDevolucao"
                :titulo-id="'myChartAnaliseProdutoDevolucao'"
                :exibir-legenda="false"
                :padding="dynamicPaddingAnaliseProduto2"
                :loading="loadingAnaliseProdutoDevolucao"
              />
            </v-col>
          </v-row><br>
          <v-row>
            <v-col
              id="componenteAnaliseProduto"
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <v-card
                id="cardDashbord"
                class="mx-auto"
                outlined
              >
                <div class="card-header-dashbord">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="10"
                      md="10"
                      lg="10"
                      class="d-flex flex-wrap"
                    >
                      Como está o faturamento dos meus grupos de itens?
                    </v-col>
                    <v-col
                      cols="12"
                      sm="2"
                      md="2"
                      lg="2"
                      class="d-flex justify-end"
                    >
                      <v-tooltip top>
                        <template
                          v-slot:activator="{ on, attrs }"
                        >
                          <v-icon
                            id="iconInformationClientesParcipantes"
                            class="text-left"
                            v-bind="attrs"
                            v-on="on"
                            @mouseover="enableTexto('143')"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <div
                          v-if="codigo === '143'"
                          v-html="textoFatGrupoItens"
                        />
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </div>
                <v-card-actions>
                  <v-row id="tableFatClassificacaoMes">
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <show-faturamento-grupos-produtos-vendas />
                    </v-col>
                  </v-row>
                </v-card-actions><br><br>
              </v-card>
            </v-col>
          </v-row>
          <v-row id="comparativoFatMes">
            <v-col
              id="componenteAnaliseProduto"
              cols="12"
              sm="12"
              md="6"
              lg="6"
            >
              <dashoard-card-view
                :exibir-texto-titulo="true"
                :code-information="'296'"
                :text="'Comparativo Faturamento - R$'"
                :texto-information="textoFatxFatAnterior"
                :style-object="styleObject"
                :componente-grafico="true"
                :grafico-id="'myChartAnaliseComparativoFaturamentoMes'"
                :dados-grafico="chartBarAnaliseComparativoFaturamentoMes"
                :titulo-id="'myChartAnaliseComparativoFaturamentoMes'"
                :legenda-grafico="legendaComparativoFaturamentoMes"
                :exibir-legenda="true"
                :padding="dynamicPaddingAnaliseProduto2"
                :loading="loadingFaturamentoClassificacaoMes"
              />
            </v-col>
            <v-col
              id="componenteAnaliseProduto"
              cols="12"
              sm="12"
              md="6"
              lg="6"
            >
              <dashoard-card-view
                :exibir-texto-titulo="true"
                :code-information="'296'"
                :text="'Comparativo Volumetria'"
                :texto-information="textoFatxFatAnterior"
                :style-object="styleObject"
                :componente-grafico="true"
                :grafico-id="'myChartAnaliseComparativoVolumetriaMes'"
                :dados-grafico="chartBarAnaliseComparativoVolumetriaMes"
                :titulo-id="'myChartAnaliseComparativoVolumetriaMes'"
                :legenda-grafico="legendaComparativoVolumeMes"
                :exibir-legenda="true"
                :padding="dynamicPaddingAnaliseProduto2"
                :loading="loadingFaturamentoClassificacaoMes"
              />
            </v-col>
          </v-row>
          <v-row id="comparativoFatMes">
            <v-col
              id="componenteAnaliseProduto"
              cols="12"
              sm="12"
              md="6"
              lg="6"
            >
              <v-card
                id="cardDashbord"
                class="mx-auto"
                outlined
              >
                <div class="card-header-dashbord">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="10"
                      md="10"
                      lg="10"
                      class="d-flex flex-wrap"
                    >
                      E qual o seu MIX comercializado?
                    </v-col>
                    <v-col
                      cols="12"
                      sm="2"
                      md="2"
                      lg="2"
                      class="d-flex justify-end"
                    >
                      <v-tooltip top>
                        <template
                          v-slot:activator="{ on, attrs }"
                        >
                          <v-icon
                            id="iconInformationClientesParcipantes"
                            class="text-left"
                            v-bind="attrs"
                            v-on="on"
                            @mouseover="enableTexto('257')"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <div
                          v-if="codigo === '257'"
                          v-html="textoMixComercializado"
                        />
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </div>
                <v-card-actions>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <show-dados-mix-comercialozados
                        id="mixComercializados"
                        style="height: 550px;"
                      />
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-col>
            <v-col
              id="componenteAnaliseProduto"
              cols="12"
              sm="12"
              md="6"
              lg="6"
            >
              <v-card
                id="cardDashbord"
                class="mx-auto"
                outlined
              >
                <div class="card-header-dashbord">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="10"
                      md="10"
                      lg="10"
                      class="d-flex flex-wrap"
                    >
                      Produtos não comercializados
                    </v-col>
                    <v-col
                      cols="12"
                      sm="2"
                      md="2"
                      lg="2"
                      class="d-flex justify-end"
                    >
                      <v-tooltip top>
                        <template
                          v-slot:activator="{ on, attrs }"
                        >
                          <v-icon
                            id="iconInformationClientesParcipantes"
                            class="text-left"
                            v-bind="attrs"
                            v-on="on"
                            @mouseover="enableTexto('257')"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <div
                          v-if="codigo === '257'"
                          v-html="textoMixComercializado"
                        />
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </div>
                <v-card-actions>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <show-dados-nao-comercialozados
                        id="mixNaoComercializados"
                        style="height: 550px;"
                      />
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              id="componenteAnaliseProduto"
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <v-card
                id="cardDashbord"
                class="mx-auto"
                outlined
              >
                <div class="card-header-dashbord">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="10"
                      md="10"
                      lg="10"
                      class="d-flex flex-wrap"
                    >
                      Faturamento Linha por Mês - R$
                    </v-col>
                    <v-col
                      cols="12"
                      sm="2"
                      md="2"
                      lg="2"
                      class="d-flex justify-end"
                    >
                      <v-tooltip top>
                        <template
                          v-slot:activator="{ on, attrs }"
                        >
                          <v-icon
                            id="iconInformationClientesParcipantes"
                            class="text-left"
                            v-bind="attrs"
                            v-on="on"
                            @mouseover="enableTexto('299')"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <div
                          v-if="codigo === '299'"
                          v-html="textoFatClassificacaoMes"
                        />
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </div>
                <v-card-actions>
                  <v-row id="tableFatClassificacaoMes">
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <show-table-faturamento-classificacao-mes />
                    </v-col>
                  </v-row>
                </v-card-actions><br><br>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row><br>

      <dashboard-core-snackbar
        v-model="snackbar.visible"
        :visible="snackbar.visible"
        :timeout="snackbar.timeout"
        :color="snackbar.color"
        :message="snackbar.message"
      />
    </div>
  </v-container>
</template>

<script>
  import Permissao from '../../../../services/menu'
  import eventEmit from '../../components/core/EventoEmit'
  import Produto from '../../../../services/analiseproduto5'
  import Chart from 'chart.js'
  import ChartDataLabels from 'chartjs-plugin-datalabels'
  import html2canvas from 'html2canvas'
  import JSPDF from 'jspdf'
  import 'jspdf-autotable'

  export default {
    name: 'DashboardCliente',
    emits: ['setUpdateFiltros', 'enableFaturamento', 'disableLoading', 'disableLoadingGrafico', 'atualizarTexto'],
    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
      DashboardFiltros: () => import('../../components/core/FiltroDatas'),
      DashoardCardView: () => import('../../components/core/CardView'),
      ShowFaturamentoGruposProdutosVendas: () => import('../../components/comercial/analiseProduto5/AnaliseProduto5FatGrupoProdutos'),
      ShowTableFaturamentoClassificacaoMes: () => import('../../components/comercial/analiseProduto5/AnaliseProduto5TableFatMes'),
      ShowDadosMixComercialozados: () => import('../../components/comercial/analiseProduto5/AnaliseProdutoMixComercializados'),
      ShowDadosNaoComercialozados: () => import('../../components/comercial/analiseProduto5/AnaliseProdutoNaoComercializados'),
    },

    data: () => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObject: {
        color: localStorage.corPrimaria,
      },
      styleTexto: {
        color: '#00796B',
      },
      styleObjectMeta: {
        color: '#ed934f',
      },
      styleObjectDevolucao: {
        color: '#C62828',
      },
      paginaEnable: false,
      link: window.location.href,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      empresa: [],
      vendedor: [],
      area: [],
      redes: [],
      supervisor: [],
      receita: [],
      segmento: [],
      categoria: [],
      promotor: [],
      classificacao: [],
      linhasProducao: [],
      produtos: [],
      cidades: [],
      permissaoAnaliseProduto: false,
      enablePrimeiroDia: true,
      enableUltimoDia: true,
      enableEmpresa: true,
      enableVendedores: true,
      enableSupervisores: true,
      enableRedes: true,
      enableAreas: true,
      enableBtn: true,
      enableBtnPrint: false,
      loadingBtnPrint: true,
      enableReceita: true,
      enableSegmento: true,
      enableCategoria: true,
      enablePromotor: true,
      enableClassificacao: true,
      enableLinhasProducao: true,
      enableProdutos: true,
      enableCidades: true,
      codigo: 0,
      orientacao: [],
      textoFaturamento: '',
      textoMeta: '',
      textoFat: '',
      textoFatClassificacao: '',
      textoKgClassificacao: '',
      textoPrecoMedioClassificacao: '',
      textoFatClassificacaoMes: '',
      textoFatxFatAnterior: '',
      textoFatGrupoItens: '',
      textoDevolucaoOrcadoVendedor: '',
      textoKgFaturado: '',
      textoValorDevolucao: '',
      textoMixComercializado: '',
      codigoIds: ['100', '101', '143', '257', '295', '296', '297', '298', '299', '300', '310', '379', '381'],
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      myChart: {},
      porcentagem: parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      valorFaturamento: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorMeta: parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      porcentagemDevolucao: parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      valorDevolucao: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorKgFaturado: parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      chartBarFaturamentoClassificacao: {},
      legendaGraficoFaturamentoClassificacao: [],
      porcentagemFaturamentoClassificacao: [],
      coresFaturamentoClassificacao: [],
      chartBarFaturamentoKgGrupo: {},
      coresFaturamentoKgGrupo: [],
      chartBarFaturamentoPrecoMedio: {},
      chartAnaliseProdutoDevolucao: {},
      coresFaturamentoPrecoMedio: [],
      chartBarAnaliseComparativoFaturamentoMes: {},
      chartBarAnaliseComparativoVolumetriaMes: {},
      legendaComparativoFaturamentoMes: [
        { cor: '#4780b8', status: 'Faturamento' },
        { cor: '#cadaed', status: 'Faturamento Anterior' },
      ],
      legendaComparativoVolumeMes: [
        { cor: '#4780b8', status: 'Volume' },
        { cor: '#cadaed', status: 'Volume Anterior' },
      ],
      dynamicPaddingAnaliseProduto1: '',
      dynamicPaddingAnaliseProduto2: '',
      dynamicPaddingAnaliseProduto3: '',
      enableLegenda: false,
      faturamentoGrupoProdutosPrint: [],
      headersTableGrupoProduto: [
        { text: 'Grupo do Produto', value: 'grupo_produto', class: 'black--text title' },
        { text: 'Faturamento', value: 'faturamento', align: 'right', class: 'black--text title' },
        { text: 'Fat. Mês do Ano Anterior', value: 'faturamento_anterior', align: 'right', class: 'black--text title' },
        { text: 'Variação de Fat. Anual', value: 'variacao_anual', align: 'right', class: 'black--text title' },
        { text: 'Participação da Linha', value: 'participacao_grupo', align: 'right', class: 'black--text title' },
        { text: 'Volume', value: 'volume', align: 'right', class: 'black--text title' },
        { text: 'Preço Médio', value: 'preco_medio', align: 'right', class: 'black--text title' },
      ],
      headersTableLinha: [],
      faturamentoLinhaPrint: [],
      imprimindo: false,
      primeiroDiaPrint: '',
      ultimoDiaPrint: '',
      coresDevolucao: [],
      loadingFaturamento: false,
      loadingMeta: false,
      loadingDevolucao: false,
      loadingKgFaturado: false,
      loadingFaturamentoClassificacao: false,
      loadingFaturamentoKgGrupo: false,
      loadingFaturamentoPrecoMedio: false,
      loadingAnaliseProdutoDevolucao: false,
      loadingFaturamentoClassificacaoMes: false,
      enableFiltrosDados: false,
    }),

    created () {
      eventEmit.$on('update-dados', this.handleUpdateDados)

      eventEmit.$on('set-dados-grupo-produto', this.handleDadosGrupoProduto)

      eventEmit.$on('set-dados-faturamento-linha', this.handleDadosFaturamentoLinha)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados', this.handleUpdateDados)

      eventEmit.$off('set-dados-grupo-produto', this.handleDadosGrupoProduto)

      eventEmit.$off('set-dados-faturamento-linha', this.handleDadosFaturamentoLinha)

      window.removeEventListener('resize', this.updateDynamicPadding)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        eventEmit.$emit('atualizar_texto', 'Analise Produtos')

        this.updateDynamicPadding()

        window.addEventListener('resize', this.updateDynamicPadding)

        this.usuarioIdentificado = true

        Permissao.verificarPermissaoPaginaUsuario(localStorage.username, window.location.href, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {

          } else {
            this.$router.push('/dashboard')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        })

        Permissao.showPermissaoPagina(localStorage.username, window.location.href, localStorage.tokencontrato, this.codigoIds).then(resposta => {
          if (resposta.data.status) {
            this.permissaoAnaliseProduto = resposta.data.permissao

            this.paginaEnable = true

            this.orientacao = resposta.data.orientacao

            if (this.$store.state.versao < resposta.data.versao) {
              this.$router.go()
            }

            this.enableTexto()
          } else {
            this.$router.push('/dashboard')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.message === 'Permissão para a pagina não encontrada, metodo 8') {
            this.$router.push('/dashboard')
          }
        })
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        localStorage.removeItem('usuarioIdentificado')
        this.$router.push('/login')
      }
    },

    methods: {
      updateDynamicPadding () {
        if (window.innerWidth > 1800) {
          this.dynamicPaddingAnaliseProduto1 = 'padding-right: 16rem !important'

          this.dynamicPaddingAnaliseProduto2 = 'padding-right: 36.7rem !important'

          this.dynamicPaddingAnaliseProduto3 = 'padding-right: 101rem !important'
        } else if (window.innerWidth > 1380 && window.innerWidth <= 1800) {
          this.dynamicPaddingAnaliseProduto1 = 'padding-right: 6rem !important'

          this.dynamicPaddingAnaliseProduto2 = 'padding-right: 25rem !important'

          this.dynamicPaddingAnaliseProduto3 = 'padding-right: 60rem !important'
        } else if (window.innerWidth > 380 && window.innerWidth < 600) {
          this.dynamicPaddingAnaliseProduto1 = 'padding-right: 10rem !important'

          this.dynamicPaddingAnaliseProduto2 = 'padding-right: 10rem !important;'

          this.dynamicPaddingAnaliseProduto3 = 'padding-right: 10rem !important'
        } else if (window.innerWidth > 601 && window.innerWidth < 1000) {
          this.dynamicPaddingAnaliseProduto1 = 'padding-right: 5rem !important'

          this.dynamicPaddingAnaliseProduto2 = 'padding-right: 5rem !important;'

          this.dynamicPaddingAnaliseProduto3 = 'padding-right: 25rem !important'
        } else {
          this.dynamicPaddingAnaliseProduto1 = 'padding-right: 4.3rem !important'

          this.dynamicPaddingAnaliseProduto2 = 'padding-right: 22rem !important'

          this.dynamicPaddingAnaliseProduto3 = 'padding-right: 55rem !important'
        }
      },

      handleUpdateDados (primeiroDia, dataFinal, select, vendedores, areas, redes, supervisores, receita, segmento, classificacao, produto, cidade, categoria, promotor, linhasProducao) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.empresa = select
        this.vendedor = vendedores
        this.area = areas
        this.redes = redes
        this.supervisor = supervisores
        this.receita = receita
        this.segmento = segmento
        this.categoria = categoria
        this.promotor = promotor
        this.classificacao = classificacao
        this.linhasProducao = linhasProducao
        this.produtos = produto
        this.cidades = cidade

        localStorage.setItem('updateDadosFiltros', true)
        localStorage.setItem('dataInicial', this.primeiroDia)
        localStorage.setItem('dataFinal', this.ultimoDia)

        this.primeiroDiaPrint = primeiroDia.substring(8) + '/' + primeiroDia.substring(5, 7) + '/' + primeiroDia.substring(0, 4)
        this.ultimoDiaPrint = dataFinal.substring(8) + '/' + primeiroDia.substring(5, 7) + '/' + primeiroDia.substring(0, 4)

        this.updateDate()
      },

      handleDadosGrupoProduto (dadosGrupoProduto) {
        this.faturamentoGrupoProdutosPrint = dadosGrupoProduto
      },

      handleDadosFaturamentoLinha (headers, dadosFaturamento) {
        this.headersTableLinha = headers
        this.faturamentoLinhaPrint = dadosFaturamento
      },

      async updateDate () {
        this.enableBtnPrint = false

        eventEmit.$emit('enable-loading', true)

        eventEmit.$emit('set-update-filtros', this.primeiroDia, this.ultimoDia, this.empresa, this.vendedor, this.area, this.redes, this.supervisor, this.receita, this.segmento, this.categoria, this.promotor, this.classificacao, this.linhasProducao, this.produtos, this.cidades)

        this.valorFaturamento = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorMeta = parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        this.porcentagem = parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        this.valorDevolucao = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.porcentagemDevolucao = parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        this.valorKgFaturado = parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

        if (this.chartBarFaturamentoClassificacao.data) {
          this.chartBarFaturamentoClassificacao.destroy()
        }

        this.exibirLegenda = false

        if (this.chartBarFaturamentoKgGrupo.data) {
          this.chartBarFaturamentoKgGrupo.destroy()
        }

        this.coresFaturamentoKgGrupo = []

        if (this.chartBarFaturamentoPrecoMedio.data) {
          this.chartBarFaturamentoPrecoMedio.destroy()
        }

        this.coresFaturamentoPrecoMedio = []

        if (this.chartAnaliseProdutoDevolucao.data) {
          this.chartAnaliseProdutoDevolucao.destroy()
        }

        if (this.chartBarAnaliseComparativoFaturamentoMes.data) {
          this.chartBarAnaliseComparativoFaturamentoMes.destroy()
        }

        if (this.chartBarAnaliseComparativoVolumetriaMes.data) {
          this.chartBarAnaliseComparativoVolumetriaMes.destroy()
        }

        this.loadingFaturamento = true
        this.loadingMeta = true
        this.loadingDevolucao = true
        this.loadingKgFaturado = true
        this.loadingFaturamentoClassificacao = true
        this.loadingFaturamentoKgGrupo = true
        this.loadingFaturamentoPrecoMedio = true
        this.loadingAnaliseProdutoDevolucao = true
        this.loadingFaturamentoClassificacaoMes = true

        await Produto.showAnalise5Faturamento(this.primeiroDia, this.ultimoDia, this.empresa, this.vendedor, this.area, this.redes, this.supervisor, localStorage.tokencontrato, this.receita, this.segmento, this.categoria, this.promotor, this.classificacao, this.linhasProducao, this.produtos, this.cidades).then(resposta => {
          if (resposta.data.status) {
            this.valorFaturamento = resposta.data.valorFaturamento.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.valorMeta = resposta.data.valorMeta.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

            this.porcentagem = resposta.data.porcentagem
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.valorFaturamento = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.valorMeta = parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

            this.porcentagem = parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

            this.showSnackbar('error', 3000, 'Não há faturamento no período selecionado')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = 'Network Error'
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Datas não conferem') {
            this.error = e.data.msg
            this.showSnackbar('error', 3000, e.data.msg)
          } else if (e.data.text === 'Empresa não encontrada') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, 'Empresa não encontrada')
          }
        }).finally(f => { this.loadingFaturamento = false; this.loadingMeta = false })

        await Produto.showAnalise5ProdutoDevolucao(this.primeiroDia, this.ultimoDia, this.empresa, this.vendedor, this.area, this.redes, this.supervisor, localStorage.tokencontrato, this.receita, this.segmento, this.categoria, this.promotor, this.classificacao, this.linhasProducao, this.produtos, this.cidades).then(resposta => {
          if (resposta.data.status) {
            this.valorDevolucao = resposta.data.valorDevolucao.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.porcentagemDevolucao = resposta.data.porcentagem
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.valorDevolucao = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.porcentagemDevolucao = parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

            this.showSnackbar('error', 3000, 'Não há faturamento no período selecionado')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = 'Network Error'
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Datas não conferem') {
            this.error = e.data.msg
            this.showSnackbar('error', 3000, e.data.msg)
          } else if (e.data.text === 'Empresa não encontrada') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, 'Empresa não encontrada')
          }
        }).finally(f => { this.loadingDevolucao = false })

        await Produto.showAnaliseProdutosLitrosFaturados(this.primeiroDia, this.ultimoDia, this.empresa, this.vendedor, this.area, this.redes, this.supervisor, localStorage.tokencontrato, this.receita, this.segmento, this.categoria, this.promotor, this.classificacao, this.linhasProducao, this.produtos, this.cidades).then(resposta => {
          if (resposta.data.status) {
            this.valorKgFaturado = resposta.data.kilosFaturados.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.valorKgFaturado = parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

            this.showSnackbar('error', 3000, 'Não há faturamento no período selecionado')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = 'Network Error'
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingKgFaturado = false })

        await Produto.showAnaliseProduto5FatClassificacao(this.primeiroDia, this.ultimoDia, this.empresa, this.vendedor, this.area, this.redes, this.supervisor, localStorage.tokencontrato, this.receita, this.segmento, this.categoria, this.promotor, this.classificacao, this.linhasProducao, this.produtos, this.cidades).then(resposta => {
          if (resposta.data.status) {
            this.exibirLegenda = true

            this.legendaGraficoFaturamentoClassificacao = resposta.data.cores

            for (var i = 0; i < resposta.data.cores.length; i++) {
              const cor = resposta.data.cores[i].cor

              this.coresFaturamentoClassificacao.push(cor)
            }

            this.porcentagemFaturamentoClassificacao = resposta.data.porcentagem

            var mobile = !(window.innerWidth < 600)

            const ctx = document.getElementById('myChartAnaliseFaturamentoClassificacao').getContext('2d')

            this.chartBarFaturamentoClassificacao = new Chart(ctx, {
              plugins: [ChartDataLabels],
              type: 'horizontalBar',
              data: {
                labels: resposta.data.labels,
                datasets: [
                  {
                    label: 'Faturamento',
                    data: resposta.data.faturamento,
                    backgroundColor: this.coresFaturamentoClassificacao,
                  },
                ],
              },
              options: {
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    ticks: {
                      min: 0,
                    },
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                  yAxes: [{
                    gridLines: {
                      display: false,
                    },
                    display: mobile,
                  }],
                },
                responsive: true,
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      const porcentagem = this.porcentagemFaturamentoClassificacao[tooltipItem.index]

                      return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) + ' - ' + porcentagem + ' %'
                    },
                    title: (tooltipItem) => {
                      return resposta.data.labels[tooltipItem[0].index]
                    },
                  },
                },
                plugins: {
                  datalabels: {
                    display: true,
                    color: function (context) {
                      return '#000000'
                    },
                    font: {
                      size: 11,
                    },
                    formatter: (value) => {
                      return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                    },
                    align: 'end',
                    offset: 4,
                  },
                },
              },
            })
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.msg === 'Data inicial nao pode ser maior que a data Final') {
            if (this.chartBarFaturamentoClassificacao.data) {
              this.chartBarFaturamentoClassificacao.destroy()
            }

            this.title = false

            this.showSnackbar('error', 3000, e.data.msg)
          } else if (e.data.text === 'Empresa não encontrada') {
            if (this.chartBarFaturamentoClassificacao.data) {
              this.chartBarFaturamentoClassificacao.destroy()
            }

            this.title = false

            this.showSnackbar('error', 3000, e.data.text)
          } else if (e.data.text === 'Nao há dados para montar ao gráfico') {
            if (this.chartBarFaturamentoClassificacao.data) {
              this.chartBarFaturamentoClassificacao.destroy()
            }

            this.showSnackbar('error', 3000, e.data.text)
          }
        }).finally(f => { this.loadingFaturamentoClassificacao = false })

        await Produto.showGraficoFaturamentoLitrosGrupo(this.primeiroDia, this.ultimoDia, this.empresa, this.vendedor, this.area, this.redes, this.supervisor, localStorage.tokencontrato, this.receita, this.segmento, this.categoria, this.promotor, this.classificacao, this.linhasProducao, this.produtos, this.cidades).then(resposta => {
          if (resposta.data.status) {
            for (var i = 0; i < resposta.data.cores.length; i++) {
              const cor = resposta.data.cores[i].cor

              this.coresFaturamentoKgGrupo.push(cor)
            }

            var mobile = !(window.innerWidth < 600)

            const ctx = document.getElementById('myChartFaturamentoKgGrupo').getContext('2d')

            this.chartBarFaturamentoKgGrupo = new Chart(ctx, {
              plugins: [ChartDataLabels],
              type: 'horizontalBar',
              data: {
                labels: resposta.data.labels,
                datasets: [
                  {
                    label: 'Faturamento',
                    data: resposta.data.faturamento,
                    backgroundColor: this.coresFaturamentoKgGrupo,
                  },
                ],
              },
              options: {
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    ticks: {
                      min: 0,
                    },
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                  yAxes: [{
                    gridLines: {
                      display: false,
                    },
                    display: mobile,
                  }],
                },
                responsive: true,
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                    },
                    title: (tooltipItem) => {
                      return resposta.data.labels[tooltipItem[0].index]
                    },
                  },
                },
                plugins: {
                  datalabels: {
                    display: true,
                    color: function (context) {
                      return '#000000'
                    },
                    font: {
                      size: 11,
                    },
                    formatter: (value) => {
                      return value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                    },
                    align: 'end',
                    offset: 4,
                  },
                },
              },
            })
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.msg === 'Data inicial nao pode ser maior que a data Final') {
            if (this.chartBarFaturamentoKgGrupo.data) {
              this.chartBarFaturamentoKgGrupo.destroy()
            }

            this.title = false

            this.showSnackbar('error', 3000, e.data.msg)
          } else if (e.data.text === 'Empresa não encontrada') {
            if (this.chartBarFaturamentoKgGrupo.data) {
              this.chartBarFaturamentoKgGrupo.destroy()
            }

            this.title = false

            this.showSnackbar('error', 3000, e.data.text)
          } else if (e.data.text === 'Nao há dados para montar ao gráfico') {
            if (this.chartBarFaturamentoKgGrupo.data) {
              this.chartBarFaturamentoKgGrupo.destroy()
            }

            this.showSnackbar('error', 3000, e.data.text)
          }
        }).finally(f => { this.loadingFaturamentoKgGrupo = false })

        await Produto.showGraficoLitrosFaturamentoPrecoMedioGrupo(this.primeiroDia, this.ultimoDia, this.empresa, this.vendedor, this.area, this.redes, this.supervisor, localStorage.tokencontrato, this.receita, this.segmento, this.categoria, this.promotor, this.classificacao, this.linhasProducao, this.produtos, this.cidades).then(resposta => {
          if (resposta.data.status) {
            for (var i = 0; i < resposta.data.cores.length; i++) {
              const cor = resposta.data.cores[i].cor

              this.coresFaturamentoPrecoMedio.push(cor)
            }

            var mobile = !(window.innerWidth < 600)

            const ctx = document.getElementById('myChartFaturamentoPrecoMedio').getContext('2d')

            this.chartBarFaturamentoPrecoMedio = new Chart(ctx, {
              plugins: [ChartDataLabels],
              type: 'horizontalBar',
              data: {
                labels: resposta.data.labels,
                datasets: [
                  {
                    label: 'Faturamento',
                    data: resposta.data.faturamento,
                    backgroundColor: this.coresFaturamentoPrecoMedio,
                  },
                ],
              },
              options: {
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    ticks: {
                      min: 0,
                    },
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                  yAxes: [{
                    gridLines: {
                      display: false,
                    },
                    display: mobile,
                  }],
                },
                responsive: true,
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                    },
                    title: (tooltipItem) => {
                      return resposta.data.labels[tooltipItem[0].index]
                    },
                  },
                },
                plugins: {
                  datalabels: {
                    display: true,
                    color: function (context) {
                      return '#000000'
                    },
                    font: {
                      size: 11,
                    },
                    formatter: (value) => {
                      return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                    },
                    align: 'end',
                    offset: 4,
                  },
                },
              },
            })
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.msg === 'Data inicial nao pode ser maior que a data Final') {
            if (this.chartBarFaturamentoPrecoMedio.data) {
              this.chartBarFaturamentoPrecoMedio.destroy()
            }

            this.title = false

            this.showSnackbar('error', 3000, e.data.msg)
          } else if (e.data.text === 'Empresa não encontrada') {
            if (this.chartBarFaturamentoPrecoMedio.data) {
              this.chartBarFaturamentoPrecoMedio.destroy()
            }

            this.title = false

            this.showSnackbar('error', 3000, e.data.text)
          } else if (e.data.text === 'Nao há dados para montar ao gráfico') {
            if (this.chartBarFaturamentoPrecoMedio.data) {
              this.chartBarFaturamentoPrecoMedio.destroy()
            }

            this.showSnackbar('error', 3000, e.data.text)
          }
        }).finally(f => { this.loadingFaturamentoPrecoMedio = false })

        await Produto.showAnaliseProduto5DevolucaoLinha(this.primeiroDia, this.ultimoDia, this.empresa, this.vendedor, this.area, this.redes, this.supervisor, localStorage.tokencontrato, this.receita, this.segmento, this.categoria, this.promotor, this.classificacao, this.linhasProducao, this.produtos, this.cidades).then(resposta => {
          if (resposta.data.status) {
            this.exibirLegenda = true

            const ctx = document.getElementById('myChartAnaliseProdutoDevolucao').getContext('2d')

            var mobile = !(window.innerWidth < 600)

            for (var i = 0; i < resposta.data.cores.length; i++) {
              const cor = resposta.data.cores[i].cor

              this.coresDevolucao.push(cor)
            }

            this.chartAnaliseProdutoDevolucao = new Chart(ctx, {
              plugins: [ChartDataLabels],
              type: 'horizontalBar',
              data: {
                labels: resposta.data.labels,
                datasets: [
                  {
                    label: 'Valor Devolução',
                    data: resposta.data.devolucao,
                    backgroundColor: this.coresDevolucao,
                    order: 1,
                  },
                ],
              },
              options: {
                plugins: {
                  datalabels: {
                    display: mobile,
                    color: function (context) {
                      return '#000000'
                    },
                    font: {
                      size: 14,
                    },
                    formatter: (value) => {
                      return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                    },
                    align: 'end',
                    offset: 4,
                  },
                },
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    ticks: {
                      min: 0,
                    },
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                  yAxes: [{
                    gridLines: {
                      display: false,
                    },
                    display: mobile,
                  }],
                },
                responsive: true,
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                    },
                    title: (tooltipItem) => {
                      return tooltipItem[0].xLabel + ' - Valor Devolução'
                    },
                  },
                  titleFontSize: 16,
                  bodyFontSize: 16,
                },
              },
            })
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingAnaliseProdutoDevolucao = false })

        await Produto.showAnaliseCompartivoFaturamentoLitrosMes(this.primeiroDia, this.ultimoDia, this.empresa, this.vendedor, this.area, this.redes, this.supervisor, localStorage.tokencontrato, this.receita, this.segmento, this.categoria, this.promotor, this.classificacao, this.linhasProducao, this.produtos, this.cidades).then(resposta => {
          if (resposta.data.status) {
            this.exibirLegenda = true

            const ctx = document.getElementById('myChartAnaliseComparativoFaturamentoMes').getContext('2d')

            const isLargeScreen = window.innerWidth > 1380

            const labelFontSize = isLargeScreen ? 20 : 14

            this.chartBarAnaliseComparativoFaturamentoMes = new Chart(ctx, {
              type: 'line',
              data: {
                labels: resposta.data.labels,
                datasets: [
                  {
                    label: 'Faturamento',
                    data: resposta.data.faturamento,
                    borderColor: '#4780b8',
                    backgroundColor: 'transparent',
                    order: 2,
                    tension: 0.2,
                    pointRadius: 5,
                    pointBackgroundColor: '#4780b8',
                  },
                  {
                    label: 'Faturamento Anterior',
                    data: resposta.data.faturamentoAnterior,
                    borderColor: '#cadaed',
                    backgroundColor: 'transparent',
                    order: 1,
                    tension: 0.2,
                    pointRadius: 5,
                    pointBackgroundColor: '#cadaed',
                  },
                ],
              },
              options: {
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    gridLines: {
                      display: false,
                    },
                    ticks: {
                      display: true,
                      fontSize: labelFontSize,
                    },
                  }],
                  yAxes: [{
                    gridLines: {
                      display: true,
                      color: '#d3d3d3',
                      lineWidth: 0.5,
                      drawBorder: false,
                    },
                    display: true,
                  }],
                },
                responsive: true,
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                    },
                    title: (tooltipItem) => {
                      if (tooltipItem[0].datasetIndex === 0) {
                        return tooltipItem[0].xLabel + ' - ' + resposta.data.ano
                      } else {
                        var ano = resposta.data.ano - 1
                        return tooltipItem[0].xLabel + ' - ' + ano
                      }
                    },
                  },
                  titleFontSize: 16,
                  bodyFontSize: 16,
                },
              },
            })

            const ctxVolumetria = document.getElementById('myChartAnaliseComparativoVolumetriaMes').getContext('2d')

            this.chartBarAnaliseComparativoVolumetriaMes = new Chart(ctxVolumetria, {
              type: 'line',
              data: {
                labels: resposta.data.labels,
                datasets: [
                  {
                    label: 'Faturamento',
                    data: resposta.data.volume,
                    borderColor: '#4780b8',
                    backgroundColor: 'transparent',
                    order: 2,
                    tension: 0.2,
                    pointRadius: 5,
                    pointBackgroundColor: '#4780b8',
                  },
                  {
                    label: 'Faturamento Anterior',
                    data: resposta.data.volumeAnterior,
                    borderColor: '#cadaed',
                    backgroundColor: 'transparent',
                    order: 1,
                    tension: 0.2,
                    pointRadius: 5,
                    pointBackgroundColor: '#cadaed',
                  },
                ],
              },
              options: {
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    gridLines: {
                      display: false,
                    },
                    ticks: {
                      display: true,
                      fontSize: labelFontSize,
                    },
                  }],
                  yAxes: [{
                    gridLines: {
                      display: true,
                      color: '#d3d3d3',
                      lineWidth: 0.5,
                      drawBorder: false,
                    },
                    display: true,
                  }],
                },
                responsive: true,
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                    },
                    title: (tooltipItem) => {
                      if (tooltipItem[0].datasetIndex === 0) {
                        return tooltipItem[0].xLabel + ' - ' + resposta.data.ano
                      } else {
                        var ano = resposta.data.ano - 1
                        return tooltipItem[0].xLabel + ' - ' + ano
                      }
                    },
                  },
                  titleFontSize: 16,
                  bodyFontSize: 16,
                },
              },
            })
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.msg === 'Data inicial nao pode ser maior que a data Final') {
            if (this.chartBarAnaliseComparativoFaturamentoMes.data) {
              this.chartBarAnaliseComparativoFaturamentoMes.destroy()
            }

            this.title = false

            this.showSnackbar('error', 3000, e.data.msg)
          } else if (e.data.text === 'Empresa não encontrada') {
            if (this.chartBarAnaliseComparativoFaturamentoMes.data) {
              this.chartBarAnaliseComparativoFaturamentoMes.destroy()
            }

            this.title = false

            this.showSnackbar('error', 3000, e.data.text)
          } else if (e.data.text === 'Nao há dados para montar ao gráfico') {
            if (this.chartBarAnaliseComparativoFaturamentoMes.data) {
              this.chartBarAnaliseComparativoFaturamentoMes.destroy()
            }

            this.showSnackbar('error', 3000, e.data.text)
          }
        }).finally(f => { this.loadingFaturamentoClassificacaoMes = false })

        this.handleBtnPrint()
      },

      handleBtnPrint () {
        this.enableBtnPrint = true
      },

      async imprimir () {
        try {
          this.imprimindo = true

          await setTimeout(() => {
            this.print()
          }, 2000)
        } catch (error) {
          console.error('Erro ao imprimir:', error)
        }
      },

      quebrarString (str, limiteCaracteresPorLinha) {
        const palavras = str.split(' ')
        let linhaAtual = ''
        const linhas = []

        palavras.forEach(palavra => {
          if ((linhaAtual + palavra).length <= limiteCaracteresPorLinha) {
            linhaAtual += palavra + ' '
          } else {
            linhas.push(linhaAtual.trim())
            linhaAtual = palavra + ' '
          }
        })

        if (linhaAtual !== '') {
          linhas.push(linhaAtual.trim())
        }

        return linhas
      },

      async print () {
        try {
          const pdf = new JSPDF('landscape', 'mm')

          // Função para adicionar tabela e controlar quebra de página
          const addTable = async (data, headers, title, posY, fontSize) => {
            pdf.text(title, 15, posY)
            posY += pdf.getTextDimensions(title).h /* + 5 */

            pdf.autoTable({
              head: [headers.map(header => ({ content: header.text, styles: { fontSize: fontSize, textColor: [0, 0, 0] } }))],
              body: data.map(row => row.map(cell => ({ content: cell, styles: { fontSize: 8, textColor: [0, 0, 0] } }))),
              startY: posY,
              styles: { fontSize: fontSize },
            })

            if (title !== 'E os que mais estão caindo?') {
              await pdf.addPage()
            }

            posY = 20

            return posY
          }

          // Definir a margem esquerda
          const marginLeftRem = -1
          const marginLeftPx = marginLeftRem * 16
          let posYFiltros = 10

          const title = 'Filtros selecionados'
          pdf.text(title, 105, posYFiltros)

          const dataInicial = this.primeiroDia.substr(8) + '/' + this.primeiroDia.substr(5, 2) + '/' + this.primeiroDia.substr(0, 4)
          const ultimoDia = this.ultimoDia.substr(8) + '/' + this.ultimoDia.substr(5, 2) + '/' + this.ultimoDia.substr(0, 4)

          const datas = 'Data inicial: ' + dataInicial + ' - Data final: ' + ultimoDia
          posYFiltros += 10
          pdf.setFontSize(10)
          pdf.text(datas, 15, posYFiltros)

          posYFiltros += 10

          const adicionarFiltros = async (pdf, posYFiltros, titulo, dados) => {
            if (dados.length > 0) {
              let texto = titulo + ' '

              for (let i = 0; i < dados.length; i++) {
                texto += dados[i] + ', '
              }

              texto = texto.slice(0, -2)

              const linhas = this.quebrarString(texto, 135)

              linhas.forEach((linha, index) => {
                if (posYFiltros === 200) {
                  pdf.addPage()

                  posYFiltros = 10

                  pdf.text(linha, 15, posYFiltros)

                  posYFiltros += 10
                } else {
                  pdf.text(linha, 15, posYFiltros)

                  posYFiltros += 10
                }
              })
            }

            return posYFiltros
          }

          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Empresa(s) Selecionada(s):', this.empresa.map(e => e.nomeExibicao))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Vendedor(es) Selecionado(s):', this.vendedor.map(v => v.vendedor))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Área(s) Selecionada(s):', this.area.map(a => a.area))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Rede(s) Selecionada(s):', this.redes.map(r => r.rede))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Supervisor(es) Selecionado(s):', this.supervisor.map(s => s.supervisor))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Receita(s) Selecionada(s):', this.receita.map(re => re.nome))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Segmento(s) Selecionado(s):', this.segmento.map(se => se.segmento))

          if (posYFiltros > 70) {
            pdf.addPage()

            posYFiltros = 10
          }

          // Adicionar a imagem dos filtros usando html2canvas
          const bloco1 = document.getElementById('bloco1IdPrint')
          const canvasBloco1Print = await html2canvas(bloco1)
          const imgWidthBloco1 = 297
          const imgHeightBloco1 = (canvasBloco1Print.height * imgWidthBloco1) / canvasBloco1Print.width

          pdf.addImage(canvasBloco1Print.toDataURL('image/png'), 'PNG', 20 + marginLeftPx, posYFiltros, imgWidthBloco1, imgHeightBloco1)

          posYFiltros += imgHeightBloco1

          const bloco2 = document.getElementById('bloco2IdPrint')
          const canvasBloco2Print = await html2canvas(bloco2)
          const imgWidthBloco2 = 297
          const imgHeightBloco2 = (canvasBloco2Print.height * imgWidthBloco2) / canvasBloco2Print.width

          pdf.addImage(canvasBloco2Print.toDataURL('image/png'), 'PNG', 20 + marginLeftPx, posYFiltros, imgWidthBloco2, imgHeightBloco2)

          pdf.addPage()
          posYFiltros = 10

          const bloco3 = document.getElementById('bloco3IdPrint')
          const canvasBloco3Print = await html2canvas(bloco3)
          const imgWidthBloco3 = 297
          const imgHeightBloco3 = (canvasBloco3Print.height * imgWidthBloco3) / canvasBloco3Print.width
          posYFiltros = 20

          pdf.addImage(canvasBloco3Print.toDataURL('image/png'), 'PNG', 20 + marginLeftPx, posYFiltros, imgWidthBloco3, imgHeightBloco3)
          pdf.addPage()

          posYFiltros = 10

          const titleTableGrupoProduto = 'Como está o faturamento dos meus grupos de itens?'
          const tableGrupoProduto = this.faturamentoGrupoProdutosPrint.map(item => [item.grupo_produto, item.faturamento, item.faturamento_anterior, item.variacao_anual, item.participacao_grupo, item.volume, item.preco_medio])
          posYFiltros = await addTable(tableGrupoProduto, this.headersTableGrupoProduto, titleTableGrupoProduto, posYFiltros, 8)

          const titleFatLinhaMes = 'Faturamento Linha por Mês - R$'
          const tablefaturamentoFaturamentoGrupoMes = this.faturamentoLinhaPrint.map(item => {
            const values = Object.keys(item).filter(key => key !== 'familia_produto' && key !== 'classificacao_total')
            return ['familia_produto', ...values, 'classificacao_total'].map(key => item[key])
          })
          posYFiltros = await addTable(tablefaturamentoFaturamentoGrupoMes, this.headersTableLinha, titleFatLinhaMes, posYFiltros, 8)

          const componenteAnaliseProduto = document.getElementById('comparativoFatMes')
          const canvasComponenteAnaliseProduto = await html2canvas(componenteAnaliseProduto)
          const imgWidthComponenteAnaliseProduto = 297
          const imgHeightComponenteAnaliseProduto = (canvasComponenteAnaliseProduto.height * imgWidthComponenteAnaliseProduto) / canvasComponenteAnaliseProduto.width
          posYFiltros = 10

          pdf.addImage(canvasComponenteAnaliseProduto.toDataURL('image/png'), 'PNG', 20 + marginLeftPx, posYFiltros, imgWidthComponenteAnaliseProduto, imgHeightComponenteAnaliseProduto)

          pdf.save('relatorio_analise_produto.pdf')
        } catch (error) {
          console.error('Erro ao gerar PDF:', error)
        } finally {
          this.faturamentoGrupoProdutosPrint = []
          this.faturamentoLinhaPrint = []
          this.headersTableLinha = []
          this.imprimindo = false
        }
      },

      enableTexto (value) {
        var i = 0

        this.codigo = value

        for (i in this.orientacao) {
          if (this.orientacao[i].codigo === '100') {
            this.textoFaturamento = this.orientacao[i].descricao
          } else if (this.orientacao[i].codigo === '101') {
            this.textoMeta = this.orientacao[i].descricao
          } else if (this.orientacao[i].codigo === '143') {
            this.textoFatGrupoItens = this.orientacao[i].descricao
          } else if (this.orientacao[i].codigo === '257') {
            this.textoMixComercializado = this.orientacao[i].descricao
          } else if (this.orientacao[i].codigo === '295') {
            this.textoFat = this.orientacao[i].descricao
          } else if (this.orientacao[i].codigo === '296') {
            this.textoFatClassificacao = this.orientacao[i].descricao
          } else if (this.orientacao[i].codigo === '297') {
            this.textoKgClassificacao = this.orientacao[i].descricao
          } else if (this.orientacao[i].codigo === '298') {
            this.textoPrecoMedioClassificacao = this.orientacao[i].descricao
          } else if (this.orientacao[i].codigo === '299') {
            this.textoFatClassificacaoMes = this.orientacao[i].descricao
          } else if (this.orientacao[i].codigo === '300') {
            this.textoFatxFatAnterior = this.orientacao[i].descricao
          } else if (this.orientacao[i].codigo === '310') {
            this.textoDevolucaoOrcadoVendedor = this.orientacao[i].descricao
          } else if (this.orientacao[i].codigo === '379') {
            this.textoKgFaturado = this.orientacao[i].descricao
          } else if (this.orientacao[i].codigo === '381') {
            this.textoValorDevolucao = this.orientacao[i].descricao
          }
        }
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }

</script>

<style scoped>
  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #textoFaturamentoAnaliseProduto {
      margin: 0 0 0 -4rem;
    }

    #iconInformationFatAnaliseProduto {
      margin: -6.5rem 0 0 0;
    }

    #iconInformationFatClassificacao {
      margin: -6.8rem 0 0 0;
    }

    #iconInformationKgClassificacao {
      margin: -6.8rem 0 0 0;
    }

    #iconInformationPrecoMedioClassificacao {
      margin: -6.8rem 0 0 0;
    }

    #iconInformationFatClassificacaoMes {
      margin: -6.8rem 0 0 0;
    }

    #iconInformationFatxFatAnterior {
      margin: -6.8rem 0 0 0;
    }

    #componenteFatLinha {
      margin: -2rem 0 -5.2rem 0;
    }

    #componenteKgTotalClassificacao {
      margin: 0 0 -5rem 0;
    }

    #componentePrecoMedioLinha {
      margin: -2rem 0 -5rem 0;
    }

    #dividirBloco1 {
      margin: -3rem 0 0 0;
    }

    /* .scroll-mobile {
      overflow-x: auto;
    } */
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 1000px)
  and (-webkit-min-device-pixel-ratio: 1) {

  }

</style>

<style lang="sass">
  .hidden
    display: none

  #textoAnaliseFaturamento
    font-size: 36px
    margin: 1.5rem 0 0 0

  #textoFaturamentoAnaliseProduto
    margin: 0 0 0 -2rem

  #btnPrint
    margin: 0.5rem 0 2rem 3rem

  #iconInformationPrecoMedioClassificacao
    maring: 0 0 0 -1rem

  #iconInformationAcumuladoAnual
    margin: 0 0 0 5rem

  .highlighted-item
    background-color: #2863af
    padding: 16px
    color: white
    margin: -1rem 0 0 0

  #listItemFaturamentoGrupos
    margin: -2rem 0 0 -1rem

  #listItemMeta
    margin: -2rem 0 0 -1rem

  #componenteAnaliseProdutoFaturamento
    margin: -1rem 0 0 0

  #componenteAnaliseProduto
    margin: -1rem 0 0 0

  #vlrMetaAnaliseProduto
    font-size: 22px
    font-weight: bold
    margin: -3rem 0 0 0

  #textoFaturamentoClienteProduto
    margin: 0 0 0 -1rem

  #tableFatClassificacaoMes
    margin: 0 0 0 0rem

</style>
